(function () {
  'use strict';

  var MAIN_PROP = '_lc_gift_flow';
  var MAIN_VALUE = 'main';
  var ADDON_VALUE = 'addon';

  var PROFILES = {
    standard: {
      hint: 'Add an optional message with this add-on.',
      fields: [
        {
          id: 'gift_message',
          type: 'textarea',
          label: 'Gift message (optional)',
          required: false,
          prop: 'Gift message',
          max: 240,
        },
      ],
    },
    plant: {
      hint: 'Optional note for this plant gift.',
      fields: [
        {
          id: 'gift_message',
          type: 'textarea',
          label: 'Gift message (optional)',
          required: false,
          prop: 'Gift message',
          max: 240,
        },
      ],
    },
    hamper_note: {
      hint: 'Who is this hamper for?',
      fields: [
        {
          id: 'recipient_name',
          type: 'text',
          label: 'Recipient name (optional)',
          required: false,
          prop: 'Recipient name',
          max: 60,
        },
        {
          id: 'gift_message',
          type: 'textarea',
          label: 'Gift message (optional)',
          required: false,
          prop: 'Gift message',
          max: 240,
        },
      ],
    },
    name_message: {
      hint: 'Name and message will be printed on the gift.',
      fields: [
        {
          id: 'name',
          type: 'text',
          label: 'Name on gift',
          required: true,
          prop: 'Name on gift',
          max: 40,
        },
        {
          id: 'gift_message',
          type: 'textarea',
          label: 'Message on gift',
          required: true,
          prop: 'Message on gift',
          max: 200,
        },
      ],
    },
    message_only: {
      hint: 'Enter the exact text to print on the gift.',
      fields: [
        {
          id: 'message',
          type: 'textarea',
          label: 'Your message',
          required: true,
          prop: 'Message',
          max: 200,
        },
      ],
    },
    message_board: {
      hint: 'Message for the KitKat message board.',
      fields: [
        {
          id: 'message',
          type: 'textarea',
          label: 'Message board text',
          required: true,
          prop: 'Message board text',
          max: 120,
        },
      ],
    },
    cake: {
      hint: 'Cake icing text and optional photo for the cake top.',
      fields: [
        {
          id: 'cake_name',
          type: 'text',
          label: 'Name on cake',
          required: true,
          prop: 'Name on cake',
          max: 30,
        },
        {
          id: 'cake_message',
          type: 'text',
          label: 'Message on cake (optional)',
          required: false,
          prop: 'Message on cake',
          max: 50,
        },
        {
          id: 'photo',
          type: 'photo',
          label: 'Photo for cake top (optional)',
          required: false,
          prop: 'Customization photo',
        },
      ],
    },
    mug: {
      hint: 'Upload a photo and the name to print on the mug.',
      fields: [
        {
          id: 'photo',
          type: 'photo',
          label: 'Photo for mug',
          required: true,
          prop: 'Customization photo',
        },
        {
          id: 'name',
          type: 'text',
          label: 'Name on mug',
          required: true,
          prop: 'Name on mug',
          max: 24,
        },
        {
          id: 'gift_message',
          type: 'textarea',
          label: 'Gift message (optional)',
          required: false,
          prop: 'Gift message',
          max: 200,
        },
      ],
    },
    photo_name: {
      hint: 'Upload a photo and name for this personalised arrangement.',
      fields: [
        {
          id: 'photo',
          type: 'photo',
          label: 'Upload photo',
          required: true,
          prop: 'Customization photo',
        },
        {
          id: 'name',
          type: 'text',
          label: 'Name on gift',
          required: true,
          prop: 'Name on gift',
          max: 40,
        },
        {
          id: 'gift_message',
          type: 'textarea',
          label: 'Gift message (optional)',
          required: false,
          prop: 'Gift message',
          max: 200,
        },
      ],
    },
    couple: {
      hint: 'Names for this personalised couple gift.',
      fields: [
        {
          id: 'name_1',
          type: 'text',
          label: 'First name',
          required: true,
          prop: 'Name 1',
          max: 30,
        },
        {
          id: 'name_2',
          type: 'text',
          label: 'Second name',
          required: true,
          prop: 'Name 2',
          max: 30,
        },
        {
          id: 'gift_message',
          type: 'textarea',
          label: 'Message (optional)',
          required: false,
          prop: 'Gift message',
          max: 200,
        },
      ],
    },
  };

  var PROFILE_LABELS = {
    standard: 'Optional message',
    plant: 'Plant gift note',
    hamper_note: 'Hamper details',
    name_message: 'Name & message',
    message_only: 'Custom message',
    message_board: 'Message board',
    cake: 'Cake personalisation',
    mug: 'Photo mug',
    photo_name: 'Photo & name',
    couple: 'Couple names',
  };

  function rootPath() {
    return window.Shopify?.routes?.root || '/';
  }

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function flowValue(props) {
    if (!props) return '';
    return props[MAIN_PROP] || props['_lc_gift_flow'] || '';
  }

  function profileDef(profileId) {
    return PROFILES[profileId] || PROFILES.standard;
  }

  var GIFT_TYPE_TABS = ['flowers', 'plants', 'chocolates'];
  var GIFT_OCCASION_TABS = ['birthday', 'anniversary', 'diwali', 'home-decor'];

  function profileRequiresCustomization(profileId) {
    var def = profileDef(profileId);
    return def.fields.some(function (f) {
      return f.required;
    });
  }

  async function fetchCart() {
    var res = await fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Could not load cart');
    return res.json();
  }

  async function addVariant(variantId, extraProps) {
    var props = Object.create(null);
    props[MAIN_PROP] = ADDON_VALUE;
    if (extraProps) {
      Object.keys(extraProps).forEach(function (key) {
        if (extraProps[key] != null && String(extraProps[key]).trim() !== '') {
          props[key] = String(extraProps[key]).trim();
        }
      });
    }
    var res = await fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1, properties: props }],
      }),
    });
    var data = await res.json().catch(function () {
      return {};
    });
    if (!res.ok) {
      throw new Error(data.description || data.message || 'Could not add to cart');
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return data;
  }

  async function uploadPhoto(uploadUrl, file) {
    var body = new FormData();
    body.append('photo', file);
    var res = await fetch(uploadUrl, { method: 'POST', body: body });
    var data = await res.json().catch(function () {
      return {};
    });
    if (!res.ok) {
      throw new Error(data.error || data.message || 'Photo upload failed');
    }
    return data.url || '';
  }

  function exactProductTags(card) {
    return (card.getAttribute('data-tags') || '')
      .split('|')
      .map(function (t) {
        return t.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function usesAddonTagTaxonomy(card) {
    var tags = exactProductTags(card);
    if (tags.indexOf('gift-addon') === -1) return false;
    return tags.some(function (t) {
      return t.indexOf('addon-cat:') === 0 || t.indexOf('addon-occ:') === 0;
    });
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-lc-gift-filter-tab]');
    var cards = root.querySelectorAll('[data-lc-gift-addon-card]');
    var emptyEl = root.querySelector('[data-lc-gift-filter-empty]');
    if (!tabs.length) return;

    function cardMatchesLegacy(card, value) {
      var category = (card.getAttribute('data-lc-gift-category') || '').toLowerCase().trim();
      var occasionsStr = (card.getAttribute('data-lc-gift-occasions') || '').toLowerCase().trim();
      var occasions = occasionsStr ? occasionsStr.split(/\s+/).filter(Boolean) : [];

      if (GIFT_TYPE_TABS.indexOf(value) !== -1) {
        return category === value;
      }
      if (GIFT_OCCASION_TABS.indexOf(value) !== -1) {
        return occasions.indexOf(value) !== -1;
      }
      return false;
    }

    function cardMatchesFilter(card, mode, value) {
      if (mode === 'addon_tag') {
        return exactProductTags(card).indexOf(value) !== -1;
      }
      if (mode === 'product_type') {
        return (card.getAttribute('data-product-type') || '').toLowerCase() === value;
      }
      if (mode === 'tag') {
        return exactProductTags(card).indexOf(value) !== -1;
      }
      if (usesAddonTagTaxonomy(card)) {
        return exactProductTags(card).indexOf(value) !== -1;
      }
      return cardMatchesLegacy(card, value);
    }

    function applyFilter(tab) {
      var mode = tab.getAttribute('data-filter-mode') || 'all';
      var value = (tab.getAttribute('data-filter-value') || '').toLowerCase().trim();
      var visible = 0;
      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
      });
      cards.forEach(function (card) {
        var show = true;
        if (mode !== 'all' && value) {
          show = cardMatchesFilter(card, mode, value);
        }
        if (show) visible += 1;
        card.hidden = !show;
        card.classList.toggle('lc-gift-addons__card--filtered-out', !show);
        card.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      if (emptyEl) {
        var showEmpty = mode !== 'all' && value && visible === 0;
        emptyEl.hidden = !showEmpty;
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        applyFilter(tab);
      });
    });
  }

  function initCustomize(root) {
    var modal = root.querySelector('[data-lc-gift-addons-customize]');
    if (!modal) return null;

    var form = modal.querySelector('[data-lc-gift-addons-customize-form]');
    var titleEl = modal.querySelector('[data-lc-gift-addons-customize-product-title]');
    var hintEl = modal.querySelector('[data-lc-gift-addons-customize-hint]');
    var errorEl = modal.querySelector('[data-lc-gift-addons-customize-error]');
    var saveBtn = modal.querySelector('[data-lc-gift-addons-customize-save]');
    var heroImg = modal.querySelector('[data-lc-gift-addons-customize-img]');
    var heroPlaceholder = modal.querySelector('[data-lc-gift-addons-customize-img-placeholder]');
    var heroPrice = modal.querySelector('[data-lc-gift-addons-customize-price]');
    var profileLabelEl = modal.querySelector('[data-lc-gift-addons-customize-profile-label]');
    var uploadUrl = (root.getAttribute('data-customize-upload-url') || '').trim();

    var activeCard = null;
    var savedByProduct = new Map();

    function setError(msg) {
      if (!errorEl) return;
      if (!msg) {
        errorEl.hidden = true;
        errorEl.textContent = '';
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = msg;
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('lc-gift-addons-customize-open');
      activeCard = null;
      setError('');
    }

    function attachCharCounter(input, max) {
      if (!max || !input) return;
      var counter = document.createElement('span');
      counter.className = 'lc-gift-addons-customize__counter';
      function sync() {
        var len = (input.value || '').length;
        counter.textContent = len + ' / ' + max;
        counter.classList.toggle('is-limit', len >= max);
      }
      input.addEventListener('input', sync);
      sync();
      input.parentElement?.appendChild(counter);
    }

    function buildPhotoField(wrap, field, saved) {
      wrap.classList.add('lc-gift-addons-customize__field--photo');
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/jpeg,image/png,image/webp,image/gif';
      input.id = 'lc-gift-cf-' + field.id;
      input.className = 'lc-gift-addons-customize__file-input';
      input.dataset.fieldId = field.id;
      input.dataset.fieldProp = field.prop;
      input.dataset.fieldRequired = field.required ? '1' : '0';
      input.dataset.fieldType = 'photo';

      var zone = document.createElement('button');
      zone.type = 'button';
      zone.className = 'lc-gift-addons-customize__upload';
      zone.innerHTML =
        '<span class="lc-gift-addons-customize__upload-icon" aria-hidden="true"></span>' +
        '<span class="lc-gift-addons-customize__upload-text"><strong>Upload your photo</strong><span>JPG or PNG · max 5 MB</span></span>';

      var preview = document.createElement('img');
      preview.className = 'lc-gift-addons-customize__upload-preview';
      preview.alt = '';
      preview.hidden = true;

      var fileName = document.createElement('p');
      fileName.className = 'lc-gift-addons-customize__photo-note';
      fileName.setAttribute('data-lc-gift-photo-preview', field.id);

      zone.addEventListener('click', function () {
        input.click();
      });

      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) return;
        fileName.textContent = file.name;
        var reader = new FileReader();
        reader.onload = function () {
          preview.src = reader.result;
          preview.hidden = false;
          zone.classList.add('has-image');
        };
        reader.readAsDataURL(file);
      });

      if (saved && saved.photoNames && saved.photoNames[field.id]) {
        fileName.textContent = 'Saved: ' + saved.photoNames[field.id];
      }

      wrap.appendChild(zone);
      wrap.appendChild(preview);
      wrap.appendChild(input);
      wrap.appendChild(fileName);
    }

    function openModal(card) {
      activeCard = card;
      var profileId = card.getAttribute('data-lc-gift-customize-profile') || 'standard';
      var def = profileDef(profileId);
      var productTitle = card.getAttribute('data-product-title') || 'Customize';
      var productId = card.getAttribute('data-product-id');
      var imgUrl = card.getAttribute('data-product-image') || '';
      var priceText = card.getAttribute('data-product-price') || '';

      titleEl.textContent = productTitle;
      hintEl.textContent = def.hint || '';
      if (heroPrice) heroPrice.textContent = priceText;
      if (profileLabelEl) {
        profileLabelEl.textContent = PROFILE_LABELS[profileId] || 'Personalisation';
      }
      if (heroImg && heroPlaceholder) {
        if (imgUrl) {
          heroImg.src = imgUrl;
          heroImg.alt = productTitle;
          heroImg.hidden = false;
          heroPlaceholder.hidden = true;
        } else {
          heroImg.hidden = true;
          heroPlaceholder.hidden = false;
        }
      }

      form.innerHTML = '';
      setError('');

      var saved = savedByProduct.get(productId);

      def.fields.forEach(function (field) {
        var wrap = document.createElement('div');
        wrap.className = 'lc-gift-addons-customize__field';

        var label = document.createElement('label');
        label.className = 'lc-gift-addons-customize__label';
        label.htmlFor = 'lc-gift-cf-' + field.id;
        label.textContent = field.label;
        if (field.required) {
          var req = document.createElement('span');
          req.className = 'lc-gift-addons-customize__required';
          req.textContent = 'Required';
          label.appendChild(req);
        }

        wrap.appendChild(label);

        if (field.type === 'photo') {
          buildPhotoField(wrap, field, saved);
          form.appendChild(wrap);
          return;
        }

        var input;
        if (field.type === 'textarea') {
          input = document.createElement('textarea');
          input.rows = 3;
          input.placeholder = field.required ? 'Enter text exactly as it should appear' : 'Optional';
        } else {
          input = document.createElement('input');
          input.type = 'text';
          input.placeholder = field.required ? 'Required' : 'Optional';
        }
        input.id = 'lc-gift-cf-' + field.id;
        input.className = 'lc-gift-addons-customize__input';
        input.dataset.fieldId = field.id;
        input.dataset.fieldProp = field.prop;
        input.dataset.fieldRequired = field.required ? '1' : '0';
        input.dataset.fieldType = field.type;
        if (field.max) input.maxLength = field.max;

        if (saved && saved.values && saved.values[field.id]) {
          input.value = saved.values[field.id];
        }

        wrap.appendChild(input);
        attachCharCounter(input, field.max);
        form.appendChild(wrap);
      });

      modal.hidden = false;
      document.body.classList.add('lc-gift-addons-customize-open');
      var first = form.querySelector('.lc-gift-addons-customize__input:not(.lc-gift-addons-customize__file-input), textarea');
      first?.focus();
    }

    modal.querySelectorAll('[data-lc-gift-addons-customize-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    async function collectFormValues() {
      var values = Object.create(null);
      var photoNames = Object.create(null);
      var props = Object.create(null);
      var files = [];

      var fields = form.querySelectorAll('[data-field-id]');
      for (var i = 0; i < fields.length; i++) {
        var el = fields[i];
        var id = el.dataset.fieldId;
        var prop = el.dataset.fieldProp;
        var required = el.dataset.fieldRequired === '1';
        var type = el.dataset.fieldType;

        if (type === 'photo') {
          var file = el.files && el.files[0];
          if (required && !file) {
            var saved = activeCard && savedByProduct.get(activeCard.getAttribute('data-product-id'));
            if (!saved || !saved.props[prop]) {
              throw new Error('Please upload a photo.');
            }
            props[prop] = saved.props[prop];
            continue;
          }
          if (file) {
            files.push({ prop: prop, file: file, id: id });
            photoNames[id] = file.name;
          } else if (activeCard) {
            var prev = savedByProduct.get(activeCard.getAttribute('data-product-id'));
            if (prev && prev.props[prop]) props[prop] = prev.props[prop];
          }
          continue;
        }

        var val = (el.value || '').trim();
        if (required && !val) {
          throw new Error('Please fill in: ' + (el.labels?.[0]?.textContent || id));
        }
        if (val) {
          values[id] = val;
          props[prop] = val;
        }
      }

      for (var j = 0; j < files.length; j++) {
        var item = files[j];
        if (uploadUrl) {
          var url = await uploadPhoto(uploadUrl, item.file);
          props[item.prop] = url;
        } else {
          props[item.prop] = 'Photo: ' + item.file.name + ' (share via WhatsApp to confirm)';
        }
      }

      return { values: values, props: props, photoNames: photoNames };
    }

    saveBtn.addEventListener('click', async function () {
      if (!activeCard) return;
      setError('');
      saveBtn.disabled = true;
      try {
        var result = await collectFormValues();
        var productId = activeCard.getAttribute('data-product-id');
        savedByProduct.set(productId, {
          props: result.props,
          values: result.values,
          photoNames: result.photoNames,
          complete: true,
        });
        updateCardCustomizeState(activeCard, true);
        closeModal();
      } catch (err) {
        setError(err.message || 'Could not save customization');
      } finally {
        saveBtn.disabled = false;
      }
    });

    function updateCardCustomizeState(card, done) {
      var status = card.querySelector('[data-lc-gift-addon-customize-status]');
      var btnLabel = card.querySelector('[data-lc-gift-customize-btn-label]');
      var note = card.querySelector('[data-lc-gift-addon-personalise-note]');
      if (done) {
        card.classList.add('lc-gift-addons__card--customized');
        if (note) note.hidden = true;
        if (status) {
          status.classList.remove('visually-hidden');
          status.textContent = 'Personalisation saved';
        }
        if (btnLabel) btnLabel.textContent = 'Edit';
      } else {
        card.classList.remove('lc-gift-addons__card--customized');
        if (note && profileRequiresCustomization(card.getAttribute('data-lc-gift-customize-profile') || 'standard')) {
          note.hidden = false;
        }
        if (status) {
          status.classList.add('visually-hidden');
          status.textContent = '';
        }
        if (btnLabel) btnLabel.textContent = 'Personalise';
      }
    }

    function getSavedProps(card) {
      var productId = card.getAttribute('data-product-id');
      var saved = savedByProduct.get(productId);
      return saved && saved.props ? saved.props : null;
    }

    function needsCustomizationBeforeAdd(card) {
      var profileId = card.getAttribute('data-lc-gift-customize-profile') || 'standard';
      if (!profileRequiresCustomization(profileId)) return false;
      var saved = savedByProduct.get(card.getAttribute('data-product-id'));
      return !(saved && saved.complete);
    }

    root.querySelectorAll('[data-lc-gift-addon-customize]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-lc-gift-addon-card]');
        if (card) openModal(card);
      });
    });

    root.querySelectorAll('[data-lc-gift-addon-card]').forEach(function (card) {
      var profileId = card.getAttribute('data-lc-gift-customize-profile') || 'standard';
      var note = card.querySelector('[data-lc-gift-addon-personalise-note]');
      if (profileRequiresCustomization(profileId)) {
        card.classList.add('lc-gift-addons__card--needs-personalisation');
        if (note) {
          note.hidden = false;
          note.textContent = 'Personalisation required before adding';
        }
      }
    });

    return {
      getSavedProps: getSavedProps,
      needsCustomizationBeforeAdd: needsCustomizationBeforeAdd,
      openForCard: openModal,
    };
  }

  function initCards(root, customizeApi) {
    root.querySelectorAll('[data-lc-gift-addon-card]').forEach(function (card) {
      var addBtn = card.querySelector('[data-lc-gift-addon-add]');
      var select = card.querySelector('[data-lc-gift-addon-variant]');
      var priceEl = card.querySelector('[data-lc-gift-addon-price]');
      if (!addBtn) return;

      function syncVariant() {
        var variantId;
        var priceCents;
        if (select && select.tagName === 'SELECT') {
          var opt = select.options[select.selectedIndex];
          if (!opt || opt.disabled) return;
          variantId = opt.value;
          priceCents = opt.getAttribute('data-price');
        } else if (select) {
          variantId = select.value;
          priceCents = select.getAttribute('data-price');
        } else {
          variantId = addBtn.getAttribute('data-variant-id');
        }
        if (variantId) addBtn.setAttribute('data-variant-id', variantId);
        if (priceEl && priceCents) priceEl.textContent = formatMoney(Number(priceCents));
      }

      select?.addEventListener('change', syncVariant);
      syncVariant();

      addBtn.addEventListener('click', async function () {
        if (addBtn.disabled || addBtn.classList.contains('is-added')) return;

        if (customizeApi && customizeApi.needsCustomizationBeforeAdd(card)) {
          customizeApi.openForCard(card);
          return;
        }

        var id = addBtn.getAttribute('data-variant-id');
        if (!id) return;
        var extra = customizeApi ? customizeApi.getSavedProps(card) : null;

        addBtn.disabled = true;
        try {
          await addVariant(id, extra);
          addBtn.classList.add('is-added');
          addBtn.textContent = 'Added ✓';
          root.dispatchEvent(new CustomEvent('lc:gift-addons-cart-updated'));
        } catch (err) {
          addBtn.disabled = false;
          window.alert(err.message || 'Could not add to cart');
        }
      });
    });
  }

  function renderBar(root, cart) {
    var mainList = root.querySelector('[data-lc-gift-bar-main]');
    var addonList = root.querySelector('[data-lc-gift-bar-addons]');
    var totalEl = root.querySelector('[data-lc-gift-bar-total]');
    if (!mainList || !addonList || !totalEl) return;

    var mainItems = [];
    var addonItems = [];
    (cart.items || []).forEach(function (item) {
      var flow = flowValue(item.properties);
      if (flow === MAIN_VALUE) {
        mainItems.push(item);
      } else if (flow === ADDON_VALUE) {
        addonItems.push(item);
      } else if (!flow && mainItems.length === 0) {
        mainItems.push(item);
      } else if (!flow) {
        addonItems.push(item);
      }
    });

    function lineHtml(items) {
      if (!items.length) return '<li>—</li>';
      return items
        .map(function (item) {
          return (
            '<li>' +
            (item.product_title || item.title) +
            (item.quantity > 1 ? ' × ' + item.quantity : '') +
            ' · ' +
            formatMoney(item.final_line_price) +
            '</li>'
          );
        })
        .join('');
    }

    mainList.innerHTML = lineHtml(mainItems);
    addonList.innerHTML = lineHtml(addonItems);
    totalEl.textContent = formatMoney(cart.total_price || 0);
  }

  function initBar(root) {
    var checkout = root.querySelector('[data-lc-gift-bar-checkout]');
    var skip = root.querySelector('[data-lc-gift-bar-skip]');
    var checkoutUrl = root.getAttribute('data-checkout-url') || rootPath() + 'checkout';
    if (checkout) checkout.setAttribute('href', checkoutUrl);
    skip?.addEventListener('click', function () {
      window.location.href = checkoutUrl;
    });

    async function refresh() {
      try {
        var cart = await fetchCart();
        renderBar(root, cart);
      } catch (_) {
        /* keep previous bar state */
      }
    }

    root.addEventListener('lc:gift-addons-cart-updated', refresh);
    refresh();
  }

  function init() {
    var root = document.querySelector('[data-lc-gift-addons-page]');
    if (!root) return;
    initTabs(root);
    var customizeApi = initCustomize(root);
    initCards(root, customizeApi);
    initBar(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
